import {
  Datagrid,
  FunctionField,
  ListContextProvider,
  NumberField,
  ReferenceField,
  WithRecord,
} from 'react-admin';
import { useListController, useListFilterContext, useTranslate } from 'ra-core';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Report } from './types';

const BrandPerformanceGrid = () => {
  const t = useTranslate();
  const { filterValues } = useListFilterContext();
  const offersByBrandController = useListController({
    resource: 'reports/offers-by-brand',
    filter: filterValues,
    perPage: Infinity,
    sort: { field: 'brand_id', order: 'ASC' },
    disableSyncWithLocation: true,
  });

  return (
    <ListContextProvider value={offersByBrandController}>
      <div className="rounded-lg border border-border bg-card w-full">
        <div className="px-6 pb-2 flex flex-col items-start">
          <div className="w-full">
            <p className="text-lg font-semibold my-4">
              {t('reporting.brand_performance')}
            </p>
            <Datagrid
              bulkActionButtons={false}
              sx={{
                '& .RaDatagrid-headerCell': {
                  p: 2,
                  fontWeight: 'bold',
                },
                '& .RaDatagrid-rowCell': {
                  p: 2,
                },
                '& .MuiTableRow-root:last-of-type td': {
                  borderBottom: 'none',
                },
              }}
            >
              <FunctionField<Report>
                label="Brand"
                sortBy="brand_name"
                render={report => {
                  return report ? (
                    <div className="flex items-center gap-2">
                      <ReferenceField source="brand_id" reference="brands">
                        <WithRecord
                          render={brand => {
                            return (
                              <Avatar className="size-10 rounded-md">
                                <AvatarImage
                                  src={brand.logo}
                                  alt={brand.name}
                                />
                                <AvatarFallback className="rounded-md">
                                  {brand.name?.charAt(0)}
                                </AvatarFallback>
                              </Avatar>
                            );
                          }}
                        />
                      </ReferenceField>
                      <div className="flex flex-col gap-1">
                        <p className="text-base truncate">
                          {report.brand_name}
                        </p>
                      </div>
                    </div>
                  ) : null;
                }}
              />
              <NumberField source="impressions" label="Impressions" />
              <NumberField source="clicks" label="Clicks" />
              {
                //<NumberField source="actions" label="Actions" />
              }
            </Datagrid>
          </div>
        </div>
      </div>
    </ListContextProvider>
  );
};

export default BrandPerformanceGrid;
